import * as angular from "angular";
import * as _ from "lodash";
import { FeatureService } from "../services/feature.service";

export class Feature {
    public readonly permissions = {
        2: "owner",
        3: "campaignmanager",
        4: "campaignstaffer",
        5: "leadcanvasser",
        6: "canvasser",
        8: "organisationowner",
        9: "organisationleader",
        10: "divisionmanager",
    };

    public attributes: any;
    public status: string;
    public id: string | number | undefined;

    public owner?: boolean;
    public campaignmanager: boolean | undefined;
    public campaignstaffer: boolean | undefined;
    public canvasser: boolean | undefined;
    public leadcanvasser: boolean | undefined;
    public organisationleader: boolean | undefined;
    public organisationowner: boolean | undefined;
    public divisionmanager: boolean | undefined;

    public extra?: any;
    public index?: any;
    public name?: any;

    private $q: any;
    private resource: FeatureService;

    constructor($q: any, FeatureService: FeatureService, data?: object) {
        this.$q = $q;
        this.resource = FeatureService;

        if (data) {
            this.setData(data);
        }
    }

    setData(data: object): void {
        _.merge(this, data);
    }

    disabled(permissionId: string, featurePermissionId: string): boolean {
        const permissionIdInt = parseInt(permissionId);

        if ([2, 8, 9].indexOf(permissionIdInt) > -1) return false;
        return !(
            permissionIdInt === 3 &&
            [3, 4, 5, 6].indexOf(parseInt(featurePermissionId)) > -1
        );
    }

    hasPermission(permissionId: string): boolean {
        const permissionIdInt = parseInt(permissionId);
        return this.attributes[this.permissions[permissionIdInt]] === 1;
    }

    show(): boolean {
        return this.status !== "Hidden";
    }

    isEnabled(): boolean {
        return this.owner;
    }

    setEnabled(bool: boolean): void {
        this.owner = bool;
        this.campaignmanager = bool;
        this.campaignstaffer = bool;
        this.canvasser = bool;
        this.leadcanvasser = bool;
        this.organisationleader = bool;
        this.organisationowner = bool;
        this.divisionmanager = bool;

        this.update();
    }

    update(): Promise<Feature> {
        const deferred = this.$q.defer();
        this.resource.update(this).then(
            (response: object) => {
                const json = response["data"];
                if (angular.isDefined(json.data)) {
                    deferred.resolve(
                        new Feature(this.$q, this.resource, json.data)
                    );
                } else {
                    deferred.reject(json.errors);
                }
            },
            (error: object) => deferred.reject(error)
        );
        return deferred.promise;
    }

    getName(): string {
        return this.name.replace("Allowed", "");
    }
}
